<script lang="ts">import { cfgBrand, cfgBrandTitle } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { closeThisModal, ModalDialog, modalStack } from "@infinitro/global";
import { MailIcon } from "@infinitro/icons";
import { Modal } from "@infinitro/modal";
import { onMount } from "svelte";
import { derived } from "svelte/store";
const thisModal = ModalDialog.Maintenance;
const closeModal = () => closeThisModal(thisModal);
const modalIndex = derived(modalStack, ($modalStack) => $modalStack.findIndex((e) => e.modal === thisModal));
const isModalOpen = derived(modalIndex, ($modalIndex) => $modalIndex >= 0);
const payload = derived(modalStack, ($modalStack) => $modalStack.find((e) => e.modal === thisModal)?.data);
const zOverlay = derived(modalIndex, ($modalIndex) => $modalIndex >= 0 ? 9999 + $modalIndex * 2 : 9999);
const label = derived(payload, ($payload) => $payload?.label);
const hardBan = derived(payload, ($payload) => $payload?.hard === true);
const BRAND_TITLE = cfgBrandTitle().toUpperCase();
const BRAND = cfgBrand();
export let onClose = undefined;
export let onSupport = undefined;
const cancelEvent = (e) => {
	e.stopPropagation();
	return false;
};
const close = (event) => {
	event?.preventDefault();
	if ($hardBan) return;
	if (onClose && typeof onClose === "function") {
		onClose();
	}
	closeThisModal(ModalDialog.Maintenance);
};
onMount(() => {
	const subtext = document.querySelector(".subtext");
	if (subtext) {
		const links = subtext.querySelectorAll("a");
		links.forEach((link) => {
			link.style.color = "#1BFFA6";
			link.style.textDecoration = "none";
		});
	}
});
</script>

<Modal
	title={null}
	{closeModal}
	width="100%"
	height="85vh"
	maxWidth="64rem"
	maxHeight="85vh"
	maxHeightContent="calc(85vh - 95px)"
	padding=""
	closeByBackdrop={true}
	showCloseButton={true}
	alwaysCentered={false}
	notFullScreenMobile={false}
	zIndexOverlay={$zOverlay}
	zIndexUnderlay={$zOverlay - 1}
>
	<div class="content">
		<p class="text main-text">
			{@html $t(Verbiage.maintenance_sorry_text, 'global', { BRAND: BRAND_TITLE })}
		</p>
		<p class="text">
			{label}
		</p>
		<p class="subtext">
			{@html $t(Verbiage.maintenance_support, 'global', { BRAND: BRAND_TITLE })}
		</p>
		<div class="links-container">
			<!-- <div class="link-item" on:click={onSupport}>
						<img
							src={SupportIcon}
							alt={$t(Verbiage.icon_alt, 'alts')}
							class="link-icon"
							aria-label="Support"
							tabindex="0"
						/>
					</div> -->
			<div class="link-item">
				<a href="mailto:support@{BRAND}">
					<MailIcon className="link-icon" ariaLabel="Email Support" tabindex="0" />
				</a>
			</div>
		</div>
	</div>
</Modal>

<style>
	@keyframes slideUp {
		from {
			transform: translateY(100%);
		}
		to {
			transform: translateY(0);
		}
	}

	.underlay {
		position: fixed;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		z-index: 10;
		height: 100%;
		width: 100%;
		overflow-y: auto;
		overflow-x: hidden;
		--tw-bg-opacity: 1;
		background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
		opacity: 0.2;
}
	.overlay {
		position: fixed;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		z-index: 10;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: center;
		overflow-y: auto;
		overflow-x: hidden;
		animation: slideUp 0.3s ease-out;
}
	.center {
		position: absolute;
		top: auto;
		margin: auto;
		max-height: 100%;
		width: 100%;
		max-width: 48rem;
		border-radius: 0.5rem;
}
	@media (min-width: 768px) {
		.center {
				position: relative;
		}
}
	.modal {
		position: relative;
		display: flex;
		height: 75vh;
		max-width: 64rem;
		flex-direction: column;
		align-items: center;
		overflow: hidden;
		border-radius: 0.5rem;
		padding-left: 0.75rem;
		padding-right: 0.75rem;
		padding-bottom: 2.5rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
		--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
	@media (min-width: 768px) {
		.modal {
				height: 45vh;
				padding-left: 1.5rem;
				padding-right: 1.5rem;
				padding-bottom: 0px;
		}
}
	.illustration {
		position: absolute;
		top: 0px;
		left: auto;
		display: none;
		height: 100%;
		width: 100%;
}
	@media (min-width: 768px) {
		.illustration {
				display: block;
		}
}
	.illustration {
		z-index: 0;
	}
	.header-icon-container {
		position: absolute;
		display: flex;
		width: 100%;
		justify-content: center;
}
	.header-icon {
		position: relative;
}
	.content {
		position: relative;
		z-index: 100;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: center;
}
	.content > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
	.content {
		text-align: center;
}
	.text {
		padding-bottom: 1.5rem;
		font-size: 1.125rem;
		line-height: 1.75rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.main-text {
		font-size: 1.25rem;
		line-height: 1.75rem;
		font-weight: 700;
}
	.subtext {
		padding-bottom: 1.5rem;
		font-size: 1rem;
		line-height: 1.5rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.links-container {
		position: absolute;
		bottom: 2.5rem;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 2rem;
}
	.link-item {
		display: flex;
		cursor: pointer;
		flex-direction: column;
		align-items: center;
		justify-content: center;
}
	.link-icon {
		height: 1.75rem;
		width: 1.75rem;
}
	button.close {
		position: absolute;
		top: 0px;
		right: 0px;
		display: flex;
		height: 2rem;
		width: 2rem;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		font-size: 1rem;
		line-height: 1.5rem;
		font-weight: 500;
		--tw-text-opacity: 1;
		color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
	button.close:hover {
		--tw-border-opacity: 1;
		border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

	@media (max-width: 768px) {
		.mobile-bottom {
				bottom: 0px;
		}
	}
</style>
